<template>
  <div>
    <div id="popuprequest" class="dataline__wrap">
      <div class="header">
        <div class="header__title">업데이트 신청 내역</div>
      </div>
      <div class="content">
        <form id="form" class="search__wrap">
          <div class="common__item__input search">
            <input
              id="minwon"
              v-model="formattedTxvscfwissNo"
              :class="{ error: txvscfwissNoErrorMsg }"
              type="text"
              placeholder="민원증명 발급번호"
              maxlength="17"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            />
            <div v-if="txvscfwissNoErrorMsg" class="error__text">{{ txvscfwissNoErrorMsg }}</div>
          </div>
          <div class="common__item__input range__picker">
            <date-picker
              v-model="startPeriod"
              placeholder="시작일"
              value-type="format"
              format="YYYY-MM-DD"
              :input-class="{ error: startPeriodErrorMsg }"
              :editable="false"
            />
            <div v-if="startPeriodErrorMsg" class="error__text">{{ startPeriodErrorMsg }}</div>
          </div>
          <div class="common__item__input range__picker dash">
            <span class="dash">-</span>
          </div>
          <div class="common__item__input range__picker">
            <date-picker
              v-model="endPeriod"
              placeholder="종료일"
              value-type="format"
              format="YYYY-MM-DD"
              :input-class="{ error: endPeriodErrorMsg }"
              :editable="false"
            />
            <div v-if="endPeriodErrorMsg" class="error__text">{{ endPeriodErrorMsg }}</div>
          </div>
          <div class="btn__wrap">
            <button
              id="resetButton"
              type="button"
              class="button round reset"
              @click="resetBtn"
            ></button>
            <button
              id="searchButton"
              type="button"
              class="button primary search"
              @click="searchBtn"
            >
              검색
            </button>
          </div>
        </form>
        <section
          class="request__status"
          role="tabpanel"
          aria-labelledby="description"
          aria-hidden="false"
        >
          <div class="section__wrap">
            <div class="section__header">
              <div class="section__title">업데이트 신청 현황</div>
            </div>
            <table class="v-simple-table type__a">
              <col width="16%" />
              <col width="52%" />
              <col width="16%" />
              <col width="16%" />
              <thead>
                <tr>
                  <th scope="col">업데이트 일자</th>
                  <th scope="col">업데이트 정보</th>
                  <th scope="col">제출회사</th>
                  <th scope="col">검증 상태</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="bizInfoList.length == 0">
                  <td colspan="4" style="text-align: center; font-size: 14px">
                    업데이트 신청 내역이 없습니다.
                  </td>
                </tr>
                <tr v-for="(item, index) in bizInfoList" :key="index">
                  <td>{{ item.rgs_dtm.substr(0, 16).replaceAll("-", ".") }}</td>
                  <td>
                    <a v-if="item.a1_rpt">사업자등록증명</a>
                    <a v-if="item.a1_rpt && item.a1_rpt1">,&nbsp;</a>
                    <a v-if="item.a1_rpt1"
                      >표준재무제표증명({{
                        item.a1_rpt1.substr(0, 4) + "." + item.a1_rpt1.substr(4, 2)
                      }})</a
                    >
                    <a v-if="item.a1_rpt1 && item.a1_rpt2">,&nbsp;</a>
                    <a v-if="item.a1_rpt2"
                      >표준재무제표증명({{
                        item.a1_rpt2.substr(0, 4) + "." + item.a1_rpt2.substr(4, 2)
                      }})</a
                    >
                    <a v-if="item.a1_rpt2 && item.a1_rpt3">,&nbsp;</a>
                    <a v-if="item.a1_rpt3"
                      >표준재무제표증명({{
                        item.a1_rpt3.substr(0, 4) + "." + item.a1_rpt3.substr(4, 2)
                      }})</a
                    >
                  </td>
                  <td>{{ item.entrnm }}</td>
                  <td>{{ item.a2_status }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { getBizInfoList } from "@/api/niceApi.js";

export default {
  name: "UpdateCheck",
  components: {
    "date-picker": DatePicker,
  },
  data() {
    return {
      startPeriod: this.initDate(-7),
      endPeriod: this.initDate(0),
      bizInfoList: [],
      txvscfwissNo: "",
      txvscfwissNoErrorMsg: "",
      startPeriodErrorMsg: "",
      endPeriodErrorMsg: "",
    };
  },
  computed: {
    formattedTxvscfwissNo: {
      get() {
        return this.txvscfwissNoFormatter(this.txvscfwissNo);
      },
      set(value) {
        // eslint-disable-next-line no-useless-escape
        value = value.replace(/\-/g, "");
        this.txvscfwissNo = value;
      },
    },
  },
  watch: {
    txvscfwissNo() {
      this.txvscfwissNoErrorMsg = "";
    },
    startPeriod() {
      this.startPeriodErrorMsg = "";
      this.endPeriodErrorMsg = "";
    },
    endPeriod() {
      this.startPeriodErrorMsg = "";
      this.endPeriodErrorMsg = "";
    },
  },
  methods: {
    txvscfwissNoFormatter(num) {
      var formatNum = "";
      formatNum = num.replace(/(\d{4})(\d{3})(\d{4})(\d{3})/, "$1-$2-$3-$4");
      return formatNum;
    },
    // reset 버튼 처리
    resetBtn() {
      this.txvscfwissNo = "";
      this.startPeriod = this.initDate(-7);
      this.endPeriod = this.initDate(0);
      // this.periodValid = false;
      this.bizInfoList = [];
    },
    // TA0108 API 호출
    searchBtn() {
      // 유효값 체크
      if (!this.validationCheck()) {
        return false;
      }

      let ta0108_param = {
        // eslint-disable-next-line no-useless-escape
        txvscfwissno: this.txvscfwissNo.replace(/\-/g, ""),
        startdate: this.startPeriod,
        enddate: this.endPeriod,
      };

      getBizInfoList(ta0108_param).then(result => {
        this.bizInfoList = result;
        console.log(result);
      });
    },
    validationCheck() {
      let result = false;

      this.txvscfwissNoErrorMsg = "";
      this.startPeriodErrorMsg = "";
      this.endPeriodErrorMsg = "";

      if (!this.txvscfwissNo || this.txvscfwissNo.length < 14) {
        this.txvscfwissNoErrorMsg = "민원증명 발급번호를 입력해주세요.";
      } else if (!this.startPeriod) {
        this.startPeriodErrorMsg = "시작일을 선택해주세요.";
      } else if (!this.endPeriod) {
        this.endPeriodErrorMsg = "종료일을 선택해주세요.";
      } else if (this.endPeriod < this.startPeriod) {
        // 시작일과 종료일 값 Valid
        // this.periodValid = true;
        this.startPeriodErrorMsg = "시작일이 종료일보다 늦을 수 없습니다.";
        this.endPeriodErrorMsg = " ";
      } else if (this.getDateDiff(this.endPeriod, this.startPeriod) > 30) {
        this.startPeriodErrorMsg = "최대 검색 가능 기간은 30일 입니다.";
        this.endPeriodErrorMsg = " ";
      } else {
        result = true;
      }
      return result;
    },
    getDateDiff(d1, d2) {
      d1 = this.startPeriod;
      d2 = this.endPeriod;

      const sdate = new Date(d1);
      const edate = new Date(d2);
      const diffDate = sdate.getTime() - edate.getTime();
      const result = Math.abs(diffDate / (1000 * 60 * 60 * 24));

      return result;
    },
    initDate(diff) {
      if (!diff) diff = 0;
      const today = new Date();
      const initDate = new Date();
      initDate.setDate(today.getDate() + diff);
      return initDate.toISOString().slice(0, 10);
    },
  },
};
</script>
